import React, { useState, useEffect } from "react";
import fetchData from "../../services/requester-website";
import { Link } from "react-router-dom";
import { imagePath } from "../../helpers/global";

const HomeDestinations = () => {
  const [data, setData] = useState([]);

  const getData = () => {
    let reqURL = "destinations";
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        data && setData(data || []);
      },
      "GET"
    );
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    data &&
    data.length > 0 && (
      <div className="home-destinations">
        <h2 className="home-title">Explore Our Top Destinations</h2>
        <p className="home-sub-title">
          Journey Through Iconic Landmarks and Exotic Hideaways in Our Top
          Picks!
        </p>
        <div className="row">
          {data?.map(
            (x, key) =>
              key < 4 && (
                <div key={key} className="col-lg-6">
                  <div className="home-destinations-wrap">
                    <img src={imagePath() + x?.imageURL} alt={x?.title} />
                    <h3>{x?.title}</h3>
                    <Link to={"destination/" + x?.destinationId} />
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};

export default HomeDestinations;
